export default __webpack_public_path__ + "static/media/lds-logo_hu.186c11fab29663cc.svg";